import { render, staticRenderFns } from "./Book.vue?vue&type=template&id=682347ab&scoped=true"
var script = {}
import style0 from "./Book.vue?vue&type=style&index=0&id=682347ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682347ab",
  null
  
)

export default component.exports